import React from "react";
import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import NoContent from "./NoContent";
import Row from "./Row";

const StaticRows = observer(
  ({ height, ofTableController }: { height: number; ofTableController: OFTableController }) => {
    console.log("RENDER StaticRows");

    const rows = [];
    const rowPositions = ofTableController.rowPositioning(height);

    let content;

    if (rowPositions.availRowCount > 0) {
      for (let i = 0; i <= rowPositions.availRowCount; i++) {
        const topPosition =
          i * ofTableController.tableRowHeight + ofTableController.headerHeight - rowPositions.leftOver;

        rows.push(
          <div
            key={i}
            className={i % 2 ? "staticRow odd" : "staticRow"}
            style={{
              position: "sticky",
              top: `${topPosition}px`,
              width: "100%",
            }}
          >
            <Row index={i} ofTableController={ofTableController} />
          </div>
        );
      }

      content = rows;
    } else {
      content = <NoContent ofTableController={ofTableController} />;
    }

    return content;
  }
);

export default StaticRows;
